import { Controller } from "@hotwired/stimulus"

// Counts the time a signed-in user spends reading a page as connected (ConnectionTrackable): pings the server
// every interval while the tab is visible, and once when it becomes visible again. Rendered by
// layouts/shared/_connection_heartbeat, never while impersonating.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 60000 }
  }

  connect () {
    this.timer = setInterval(() => this.ping(), this.intervalValue)
    this.onVisibilityChange = () => this.ping()
    document.addEventListener("visibilitychange", this.onVisibilityChange)
  }

  disconnect () {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisibilityChange)
  }

  ping () {
    if (document.visibilityState !== "visible") return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json", "X-CSRF-Token": csrfToken }
    }).then((response) => {
      // Signed out meanwhile (another tab, expired session): nothing left to count on this page.
      if (response.status === 401) this.disconnect()
    }).catch(() => {})
  }
}
